import Big from 'big.js';
/*
 *   This is the utils used by BG Core API to convert amounts to cents.
 */
export var convertToCents = function (dollarValue) {
    var amountInCents;
    if (typeof dollarValue === 'string') {
        amountInCents = parseFloat(dollarValue) * 100;
    }
    else {
        amountInCents = dollarValue * 100;
    }
    var fixedFloatingAmount = +amountInCents.toFixed(8); // Avoid rounding errors
    var floorInCents = Math.floor(fixedFloatingAmount);
    var fixedMinusFloorDiff = fixedFloatingAmount - floorInCents;
    var marginOfError = 1e-4; // Allow for rounding errors in fixedMinusFloorDiff, this is an arbitrary value
    // this line is where the magic happens. Essentially says if the difference in that last number is > .4999 and < than .5001,
    // then this is a floating point error, and we need to apply the special banker's rounding.
    var valueInMarginOfError = fixedMinusFloorDiff > 0.5 - marginOfError && fixedMinusFloorDiff < 0.5 + marginOfError;
    var roundedValue;
    if (valueInMarginOfError) {
        roundedValue = floorInCents % 2 == 0 ? floorInCents : floorInCents + 1;
    }
    else {
        //if the value is not in the margin of error, banker's rounding works the same as the default es5 Math.round() spec:
        //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
        roundedValue = Math.round(fixedFloatingAmount);
    }
    return roundedValue;
};
export var round = function (amount, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 2; }
    return Big(amount).round(decimalPlaces, Big.roundHalfEven).toString();
};
export var convertToDollars = function (centValue) {
    return Big(centValue).div(100).round(2, Big.roundHalfEven).toString();
};
